export const iOSCanInstall = 'standalone' in window.navigator;
export const iOSIsInstalled = !!window.navigator.standalone;
export const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);